"use client";
import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Select,
  FormControl,
  InputLabel,
  TextField,
  CircularProgress,
  Alert,
} from "@mui/material";
import axios from "axios";

export default function EditStatusModal({
  open,
  handleClose,
  campaign,
  onUpdateSuccess,
}) {
  const [status, setStatus] = useState("");
  const [remark, setRemark] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // ✅ Reset form when campaign changes
  useEffect(() => {
    if (campaign) {
      setStatus(campaign?.cmp_status || "");
      setRemark(campaign?.remarks || "");
    }
  }, [campaign]);

  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  };

  const handleRemarkChange = (event) => {
    setRemark(event.target.value);
  };

  const handleUpdate = async () => {
    if (!status) {
      setError("Please select a status");
      return;
    }

    setLoading(true);
    setError("");

    try {
      // ✅ Correct payload schema
      const payload = {
        id: campaign?.id,
        cmp_status: status,
        remarks: remark,
        csvData: campaign?.csvData || {},
        reinitiated: status === "reinitiated" ? 1 : 0,
      };

      console.log("📤 Sending payload:", payload);

      const response = await axios.put(
        "https://d3ioa5kdb9.execute-api.ap-south-1.amazonaws.com/Tis_whatsapp_be/status_update",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      console.log("✅ Server Response:", response.data);

      // ✅ Success Handling
      const updateStatus =
        response?.data?.body?.status_update || response?.data?.status_update;

      if (updateStatus === "status Update" || response.status === 200) {
        onUpdateSuccess?.();
        handleClose();
      } else if (updateStatus === "Update Failed") {
        setError(
          "Update failed on the server. Please verify the campaign ID exists in the database."
        );
      } else {
        setError("Unexpected response from server.");
      }
    } catch (err) {
      console.error("❌ Error updating status:", err);
      setError("Failed to update status. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setStatus("");
    setRemark("");
    setError("");
    setLoading(false);
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleCloseModal} maxWidth="xs" fullWidth>
      <DialogTitle fontWeight="bold">Update Campaign Status</DialogTitle>

      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          mt: 1,
        }}
      >
        {error && <Alert severity="error">{error}</Alert>}

        <FormControl fullWidth size="small">
          <InputLabel>Status</InputLabel>
          <Select
            native
            value={status}
            onChange={handleStatusChange}
            label="Status"
            disabled={loading}
          >
            <option value="">Select Status</option>
            <option value="completed">Completed</option>
            <option value="inprogress">Inprogress</option>
            <option value="pending">Pending</option>
            <option value="cancelled">Cancelled</option>
            <option value="failed">Failed</option>
            <option value="reinitiated">Reinitiated</option>
          </Select>
        </FormControl>

        <TextField
          size="small"
          label="Remark"
          multiline
          minRows={2}
          value={remark}
          onChange={handleRemarkChange}
          fullWidth
          disabled={loading}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleCloseModal} size="small" disabled={loading}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleUpdate}
          size="small"
          disabled={loading || !status}
        >
          {loading ? <CircularProgress size={20} /> : "Update"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
